import { Flex } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import Text from 'antd/es/typography/Text'
import React, { useEffect, useState } from 'react'
import { useUpdateQuestionAnswerNoteMutation } from '../../../../../../../../../store/apis/submission.api'

const useSyncNote = noteFromStore => {
    const [note, setNote] = useState('')

    useEffect(() => {
        setNote(noteFromStore || '')
    }, [noteFromStore])

    return [note, setNote]
}

const NoteInput = ({ submissionId, answerId, note: noteFromStore }) => {
    const [note, setNote] = useSyncNote(noteFromStore)
    const [updateQuestionAnswerNote, updateQuestionAnswerNoteResult] = useUpdateQuestionAnswerNoteMutation()

    const [showInput, setShowInput] = useState(!!noteFromStore?.trim()?.length)

    const savedStatus = useDisappearingSavedStatus(updateQuestionAnswerNoteResult)

    const handleBlur = () => {
        const noteHasChanged = note !== noteFromStore
        if (noteHasChanged) updateQuestionAnswerNote({ id: answerId, submissionId, note })
    }

    const handleChange = event => {
        setNote(event.target.value)
    }

    const normalizeNote = value => value ?? ''
    const noteChanged = normalizeNote(note) !== normalizeNote(noteFromStore)

    const status = (() => {
        if (updateQuestionAnswerNoteResult.isLoading) return 'Saving...'
        if (updateQuestionAnswerNoteResult.isError) return updateQuestionAnswerNoteResult.error
        if (noteChanged) return 'Edited'
        return savedStatus
    })()

    return (
        <label className='d-flex-column'>
            {showInput ? (
                <>
                    <Flex justify='space-between' className='f-width'>
                        <Text className='mb-8'>Note</Text>
                        {status && <Text type='secondary'>{status}</Text>}
                    </Flex>
                    <TextArea
                        value={note}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoSize
                        placeholder='Enter note for this answer'
                        disabled={updateQuestionAnswerNoteResult.isLoading}
                        variant='filled'
                    />
                </>
            ) : (
                <a onClick={() => setShowInput(true)}>Add note</a>
            )}
        </label>
    )
}

function useDisappearingSavedStatus(updateQuestionAnswerResult) {
    const [savedStatus, setSavedStatus] = useState('')

    useEffect(() => {
        if (updateQuestionAnswerResult.isSuccess) {
            setSavedStatus('Saved')
            const timer = setTimeout(() => setSavedStatus(''), 3000)
            return () => clearTimeout(timer)
        }
    }, [updateQuestionAnswerResult])

    return savedStatus
}

export default NoteInput
